import Pristine from 'pristinejs';
import { load } from 'recaptcha-v3';

import '../sass/contact.scss';

(() => {
    const $contacts = document.querySelectorAll('.contact');

    if (!$contacts) return;

    const { RECAPTCHA_V3_SITE_KEY } = GLOBALS;

    $contacts.forEach($contact => {
        const $form = $contact.querySelector('.contact__form');

        const initFormValidation = () => {
            if (!$form) return;

            const pristine = new Pristine($form);
        
            $form.addEventListener('submit', e => {
                e.preventDefault();

                if ($form.classList.contains('contact__form--loading')) {
                    return;
                }

                $form.classList.add('contact__form--loading');

                if (!pristine.validate()) {
                    $form.classList.remove('contact__form--loading');

                    return;
                }

                const $recaptchaTokenInput = $form.querySelector('.recaptcha-token');

                if (RECAPTCHA_V3_SITE_KEY && $recaptchaTokenInput) {
                    load(RECAPTCHA_V3_SITE_KEY).then((recaptcha) => {
                        recaptcha.execute('contact').then((token) => {
                            $recaptchaTokenInput.value = token;

                            $form.submit();
                        });
                    });
                } else {
                    $form.submit();
                }
            });
        };

        initFormValidation();
    });
})();
